const PHOTOS = ['https://cwscorapp-photos.s3-us-west-1.amazonaws.com/placeholder.png']

export { PHOTOS }
